import React, { useCallback, useMemo } from "react";

import Select from "antd/es/select";
import { useIntl } from "react-intl";

import ActivityStatusOption from "@mapmycustomers/shared/enum/activity/ActivityStatusOption";

import useView from "@app/component/view/utils/useView";
import { activityListViewAnalytics } from "@app/scene/activity/activityTableAnalytics";
import useActivityStatusOptions from "@app/scene/activity/utils/useActivityStatusOptions";
import getActivityStatusOptionByFilter from "@app/util/activity/getActivityStatusOptionByFilter";
import mapActivityStatusOptionToFilter from "@app/util/activity/mapActivityStatusOptionToFilter";

import styles from "./QuickStatusFilter.module.scss";

interface Props {}

const QuickStatusFilter: React.FC<Props> = () => {
  const {
    updateFilterModel,
    viewState: { filter },
  } = useView();
  const activityStatusOption: ActivityStatusOption = useMemo(
    () => getActivityStatusOptionByFilter(filter),
    [filter]
  );

  const mapStatusToIsSelected: Record<ActivityStatusOption, boolean> = {
    [ActivityStatusOption.ALL]: activityStatusOption === ActivityStatusOption.ALL,
    [ActivityStatusOption.COMPLETED]: activityStatusOption === ActivityStatusOption.COMPLETED,
    [ActivityStatusOption.INCOMPLETE]: activityStatusOption === ActivityStatusOption.INCOMPLETE,
    [ActivityStatusOption.NOT_SCHEDULED]:
      activityStatusOption === ActivityStatusOption.NOT_SCHEDULED,
    [ActivityStatusOption.OVERDUE]: activityStatusOption === ActivityStatusOption.OVERDUE,
    [ActivityStatusOption.UPCOMING]: activityStatusOption === ActivityStatusOption.UPCOMING,
  };
  const intl = useIntl();
  const activityStatusOptions = useActivityStatusOptions(intl);
  const selectedOption = activityStatusOptions.find(({ value }) => mapStatusToIsSelected[value]);

  const handleChange = useCallback(
    (status: ActivityStatusOption) => {
      updateFilterModel(mapActivityStatusOptionToFilter[status]);
    },
    [updateFilterModel]
  );

  const handleClick = useCallback(() => {
    activityListViewAnalytics.clicked(["Status Dropdown"]);
  }, []);

  return (
    <Select<ActivityStatusOption>
      className={styles.container}
      dropdownMatchSelectWidth={false}
      onChange={handleChange}
      onClick={handleClick}
      options={activityStatusOptions}
      value={selectedOption?.value}
    />
  );
};

export default QuickStatusFilter;
